import type { AxiosInstance } from "axios";
import dayjs from "dayjs";
import { downloadBlob } from "./downloadBlob.ts";

export async function downloadCsvFile(
  axiosInstance: AxiosInstance,
  {
    url,
    params,
    fileNamePrefix,
  }: {
    url: string;
    params: Record<string, string | number | boolean>;
    fileNamePrefix: string;
  },
): Promise<void> {
  const { data } = await axiosInstance.get<Blob>(url, {
    params,
    responseType: "blob",
  });
  downloadBlob(data, `${fileNamePrefix}-${dayjs().format("YYYY-MM-DD")}.csv`);
}
